/* eslint-disable */
import React, { useState } from "react";
import Svg from "_assets/svg";
import Divider from "components/Divider";
import H3 from "components/H3";
import H4 from "components/H4";
import H5 from "components/H5";
// import { channelConstant } from "_constant";
import moment from "moment";
import { useHistory } from "react-router-dom";
import styled from "styled-components";
import ButtonApplicationCard from "../ButtonApplicationCard";
import CardButton from "../CardButton";
import Button from "./Button";
import Tooltip from "./Tooltip";
import TooltipButton from "./TooltipButton";
import TooltipButtonImg from "./TooltipButtonImg";
import ModalDelete from "./ModalDelete";

const Img = styled.img`
  width: 20px;
  height: 20px;
`;

const WrapperButton = styled.div`
  position: absolute;
  top: 20px;
  right: 20px;
`;

const ButtonMonitoring = styled.div`
background-color: #3B3B47;
outline: none;
border: 0px;
text-align: center;
padding: 10px 17px;
font-size: 16px;
font-weight: 600;
color: #fff;
border-radius:6px;
margin-top:15px;
-webkit-transition: background-color 500ms linear;
-ms-transition: background-color 500ms linear;
transition: background-color 500ms linear;
&:hover {
    background-color: #111112;
}
&:focus {
    outline: 0;
}
`;

const CardApplication = (props) => {
  const { className, active, data } = props;
  // const [tooltip, setTooltip] = useState(false);
  // const [modalDelete, setModalDelete] = useState(false);
  const history = useHistory();
  // const path = "/main";
  // const successDelete = () => {
  //   setModalDelete(false);
  //   refresh();
  // };

  function toDetailPage(_id){
    history.push({
      pathname: `/my-application/detail/${_id}`,
      state: { dataDetailApp: data },
    });
  }

  return (
    <div className="position-relative">
      <CardButton className={`d-flex flex-column ${className}`}>
        <div className="position-relative d-flex flex-row justify-content-between align-items-center margin-bottom-15 w-100">
          <H3 onClick={()=> toDetailPage(data._id)} color="#383C42" className="elipsis_custom" style={{width:'85%',maxWidth:'85%'}}>{data.applicationName || data.application_name}</H3>
          <Button 
            className="position-absolute righ d-flex align-items-center fsize-14"
            onClick={() => {
              history.push({
                pathname: `/my-application/edit-application`,
                state: { id: data._id },
              });
            }}
          >
            <img className="me-2" width={13} src={Svg.edit_app.default} alt="edit app" />
            Edit
          </Button>
        </div>
        <div onClick={()=> toDetailPage(data._id)} active={active} className="w-100 margin-bottom-15 padding-bottom-20">
          <div className={`${data?.application_channels.length > 0 && 'margin-bottom-8'} d-flex flex-row w-100`} style={{ flexWrap: 'wrap' }} >
            {data?.application_channels.map((val) => {
              return (
                <>
                  {val.channel_name === 'Whatsapp' && (
                    <ButtonApplicationCard
                      fontSize="14px"
                      svg={Svg.whatsapp_primary.default}
                      title="Whatsapp"
                      textColor="#377333"
                      backgroundColor="#DFF3E0"
                      className="margin-right-10 mb-2"
                    />
                  )}
                  {val.channel_name === 'SMS' && (
                    <ButtonApplicationCard
                    fontSize="14px"
                      svg={Svg.sms_primary.default}
                      title="SMS"
                      textColor="#6F4AAF"
                      backgroundColor="#EAE2F8"
                      className="margin-right-10 mb-2"
                    />
                  )}
                  {val.channel_name === 'Call' && (
                    <ButtonApplicationCard
                    fontSize="14px"
                      svg={Svg.call_primary.default}
                      title="Call"
                      textColor="#2966BC"
                      backgroundColor="#D7E8FA"
                      className="margin-right-10 mb-2"
                    />
                  )}
                  {val.channel_name === 'Misscall OTP - OTP' && (
                    <ButtonApplicationCard
                    fontSize="14px"
                      svg={Svg.call_primary.default}
                      title="Voice OTP"
                      textColor="#2966BC"
                      backgroundColor="#D7E8FA"
                      className="margin-right-10 mb-2"
                    />
                  )}
                  {val.channel_name === 'Email' && (
                    <ButtonApplicationCard
                    fontSize="14px"
                      svg={Svg.email.default}
                      title="Email"
                      textColor="#2966BC"
                      backgroundColor="#D7E8FA"
                      className="margin-right-10 mb-2"
                    />
                  )}
                  {/* {val.channel_name === channelConstant.chatAja && (
                    <ButtonApplicationCard
                    fontSize="14px"
                      svg={Svg.chat_aja.default}
                      title="Chat Aja"
                      textColor="#2966BC"
                      backgroundColor="#D7E8FA"
                      className="margin-right-10 mb-2"
                    />
                  )} */}
                  {val.channel_name === 'SMS OTP' && (
                    <ButtonApplicationCard
                    fontSize="14px"
                      svg={Svg.sms_primary.default}
                      title="SMS OTP"
                      textColor="#2966BC"
                      backgroundColor="#D7E8FA"
                      className="margin-right-10 mb-2"
                    />
                  )}
                </>
              );
            })}
          </div>
          <div className="d-flex flex-row margin-bottom-15 w-100">
            <div className="d-flex flex-column margin-right-25">
              <H5 color="#838990">App ID</H5>
              <H4 className="number-of-lines">{data?._id || '~'}</H4>
            </div>
            <div className="d-flex flex-column">
              <H5 color="#838990">App Issued</H5>
              <H4>{moment(data.updated_at).format("DD/MM/YYYY")}</H4>
            </div>
          </div>
        </div>
        <ButtonMonitoring
          onClick={() => {
            history.push({
              pathname: `/my-application/detail-transaction/${data._id}`,
              state: { id: data._id, data },
            });
          }}
          className="d-flex align-items-center d-block"
        >
          <TooltipButtonImg src={Svg.monitoring.default} />
          Monitoring
        </ButtonMonitoring>
      </CardButton>
      {/* <WrapperButton>
        <Button className="position-relative" active={tooltip} onClick={() => setTooltip(!tooltip)}>
          <Img src={Svg.more_vert.default} />
        </Button>
        {tooltip && (
          <Tooltip className="d-flex flex-column">
            <TooltipButton
              onClick={() => {
                history.push({
                  pathname: `/my-application/edit-application`,
                  state: { id: data._id },
                });
              }}
              className="d-flex align-items-center"
            >
              <TooltipButtonImg src={Svg.edit.default} />
              Edit
            </TooltipButton>
            <div>
              <Divider className="m-0" />
            </div>
            <TooltipButton
              onClick={() => setModalDelete(true)}
              className="d-flex align-items-center"
            >
              <TooltipButtonImg src={Svg.delete.default} />
              Delete
            </TooltipButton>
          </Tooltip>
        )}
      </WrapperButton>
      <ModalDelete
        id={data._id}
        applicationName={data.applicationName || data.application_name}
        showModal={modalDelete}
        successDelete={() => successDelete()}
        handleClose={() => setModalDelete(false)}
      /> */}
    </div>
  );
};

export default CardApplication;
